export default {
    'redeemPoint.title': '扣點兌換',
    'redeemPoint.collect_success': '集點成功',
    'redeemPoint.redeem_success': '扣點成功',
    'redeemPoint.redeem_fail': '扣點失敗',
    'redeemPoint.point_not_enough': '點數不足，無法扣點',
    'redeemPoint.please_enter_quantity': '請輸入點數數量',
    'redeemPoint.next_step': '下一步',
} as Record<string, string>;
